module.exports = __webpack_public_path__ + "static/media/bts_carassauga_180526_004_small.e30d71dd.jpg";